module.exports = __webpack_public_path__ + "img/its-a-match.916c7b4f.png";